import React from "react";
import PropTypes from "prop-types";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Title, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Title, Tooltip, Legend);

export default function PieChart({ datasets, labels, title }) {
  // For pie charts, we typically use the first dataset
  const pieData = datasets[0] || { data: [], backgroundColor: [] };

  return (
    <Pie
      data={{
        labels,
        datasets: [
          {
            ...pieData,
            borderWidth: 2,
            borderColor: "#ffffff",
          },
        ],
      }}
      options={{
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "bottom",
          },
          title: {
            display: title ? true : false,
            text: title,
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                const datasetLabel = context.label || "";
                const value = context.raw;

                // Calculate percentage
                const total = context.dataset.data.reduce(
                  (sum, val) => sum + val,
                  0,
                );
                const percentage = total
                  ? ((value / total) * 100).toFixed(1)
                  : 0;

                return `${datasetLabel}: ${value} (${percentage}%)`;
              },
            },
          },
        },
      }}
    />
  );
}

PieChart.propTypes = {
  datasets: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      data: PropTypes.arrayOf(PropTypes.number).isRequired,
      backgroundColor: PropTypes.arrayOf(PropTypes.string).isRequired,
    }),
  ).isRequired,
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string,
};
